module.exports = __webpack_public_path__ + "img/透明logo.0fc017e7.png";